export const init = () => {
    // START HELPERS
    const submenu = document.querySelector('.submenu');
    const submenuType2 = document.querySelector('.submenu-2');  
    const submenuType3 = document.querySelector('.b-submenu-vertical');  

    let getPageUrl; 
    let targetActiveItem;
    let headerHeight;

    //Function for solution for active item of submenu
    const selectActiveLink = function(path) {
        getPageUrl = window.location.pathname; 
        targetActiveItem = document.querySelector(`${path} a[href='${getPageUrl}']`); 
        targetActiveItem ? targetActiveItem.classList.add('active') : console.warn('[WARN] URL for element not found.'); 
    };

    // FUNCTION for toggling submenu
    const toggleSubmenu = function(element, parent) {
        document.querySelector(`.${element}`).addEventListener('click', function(e){
            e.preventDefault(); 
            e.target.closest(`.${parent}`).classList.toggle("mobile-active");   
        }) 
    };


    // END HELPERS 

   
    // Submenu type 1
    if (submenu) {
        //solution for active item of submenu
        selectActiveLink('.submenu .submenu__content');
 
        headerHeight = document.querySelector('.header')?.offsetHeight;  
        const stickySubmenu = function() {
            if(submenu.getBoundingClientRect().y - (headerHeight / 2) < 0) {
                submenu.classList.add('submenu--scrolled'); 
            } else {
                submenu.classList.remove('submenu--scrolled'); 
            } 
        }

         if (window.innerWidth > 1055) {
            // Do it on scroll  
            window.addEventListener('scroll', () => {
                stickySubmenu();  
            });
            // Do it on load 
            stickySubmenu();  
         }

        // Solution for toggling submenu 
        toggleSubmenu('js-submenu-toggle', 'submenu'); 
    }
    
    // Submenu type 2
    if(submenuType2) {
        //solution for active item of submenu-2 
        selectActiveLink('.submenu-2 .submenu-2__content');
        // Solution for toggling submenu
        toggleSubmenu('js-submenu-2-toggle', 'submenu-2'); 
    }

     
    // Submenu type 3
    if(submenuType3) { 
        //solution for active item of submenu-3
        selectActiveLink('.b-submenu-vertical .submenu-vertical__list .b-submenu-vertical__list-item');  
    }
} 

